/* ============================================================
   NeoSpherium · recently-viewed rail ("Where you have been").
   Device-local only (localStorage), same pattern as ns-wishlist.js. On a PDP it records a
   small snapshot of the current product; on any page that contains the rail container it
   renders up to SHOW pieces (most-recent first, current product excluded). No fetches, no
   scarcity, no cross-device tracking. Fails silent if localStorage is unavailable.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'ns-recently-viewed';
  var MAX = 12;   /* how many we remember */
  var SHOW = 4;   /* how many the rail renders (matches the .edit__grid 4-up) */

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  /* --- record the current product, if this is a PDP --- */
  var currentHandle = null;
  var blob = document.querySelector('[data-ns-rv-current]');
  if (blob) {
    try {
      var p = JSON.parse(blob.textContent);
      if (p && p.handle) {
        currentHandle = p.handle;
        var list = read().filter(function (x) { return x && x.handle !== p.handle; });
        list.unshift(p);
        if (list.length > MAX) list = list.slice(0, MAX);
        write(list);
      }
    } catch (e) {}
  }

  /* --- render every rail on the page (12 Oct 2026, rebuild 2: the product page and the listing each carry one, as
     Farfetch and Net-a-Porter do; the empty bag reads the same list through window.NSRecent). Up to SHOW pieces,
     most recent first, the current product excluded; nothing yet means the rail stays hidden. --- */
  window.NSRecent = { read: function () { return read().filter(function (x) { return x && x.handle && x.handle !== currentHandle; }); } };
  var items = window.NSRecent.read().slice(0, SHOW);
  if (!items.length) return;

  /* 16 Oct 2026, Arabic slice 1. A record keeps the URL of the page it was seen on (/products/x in English,
     /ar/products/x in Arabic), so the link is re-rooted to the language the visitor is reading now. On an English
     page an English record is left exactly as stored. */
  function localUrl(u) {
    if (!u) return '#';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = String(u).replace(/^\/ar(?=\/)/, '');
    if (path.charAt(0) !== '/') return u;
    return root.replace(/\/$/, '') + path;
  }

  function tile(it, tpl) {
    var a = document.createElement('a');
    a.href = localUrl(it.url);
    a.className = 'edit__tile';
    var imgWrap = document.createElement('div');
    imgWrap.className = 'edit__img';
    if (it.image) {
      var img = document.createElement('img');
      img.src = it.image;
      img.alt = it.title || '';
      img.width = 600; img.height = 800;
      img.loading = 'lazy';
      img.decoding = 'async';
      imgWrap.appendChild(img);
    }
    a.appendChild(imgWrap);
    if (it.vendor) {
      var brand = document.createElement('span');
      brand.className = 'edit__brand';
      /* Arabic pages: window.NS_DN (layout/theme.liquid) holds the Arabic District names; English pages have none. */
      brand.textContent = ((window.NS_DN || {})[String(it.vendor).trim().toLowerCase()]) || String(it.vendor).toUpperCase();
      a.appendChild(brand);
    }
    var title = document.createElement('p');
    title.className = 'edit__title';
    title.textContent = it.title || '';
    a.appendChild(title);
    if (it.price) {
      var price = document.createElement('span');
      price.className = 'edit__price';
      /* the rail carries data-price-tpl only on a translated storefront; records saved before the amount field existed
         keep their stored price */
      price.textContent = (tpl && it.amount) ? tpl.replace('__A__', it.amount) : it.price;
      a.appendChild(price);
    }
    return a;
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ns-rv]'), function (sec) {
    var grid = sec.querySelector('[data-ns-rv-grid]');
    if (!grid || grid.children.length) return;
    var frag = document.createDocumentFragment();
    var tpl = sec.getAttribute('data-price-tpl');
    items.forEach(function (it) { frag.appendChild(tile(it, tpl)); });
    grid.appendChild(frag);
    sec.hidden = false;
  });
})();
